var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 64,
    viewBox: "0 0 56 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.48209C0 1.55898 1.55837 0 3.48072 0H70.5193C72.4416 0 74 1.55898 74 3.48209V51.6396C74 53.5627 72.4416 55.1217 70.5193 55.1217H30.279L17.6762 69.7877C16.7272 70.892 15.1916 71.2889 13.8267 70.7827C12.4618 70.2764 11.556 68.974 11.556 67.5177V55.1217H3.48072C1.55837 55.1217 0 53.5627 0 51.6396V3.48209ZM6.96143 6.96418V48.1576H15.0367C16.9591 48.1576 18.5174 49.7165 18.5174 51.6396V58.1257L26.0416 49.3697C26.7029 48.6002 27.6668 48.1576 28.6811 48.1576H67.0386V6.96418H6.96143Z",
    fill: "#0F20E8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsVerification);
export default __webpack_public_path__ + "static/media/sms_verification.80c1e85f3a0de52fa0ab0ef543178f98.svg";
export { ForwardRef as ReactComponent };